import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { InformationModalFormComponent } from 'src/app/forms-modal/_pop-ups/information-modal-form/information-modal-form.component';
import { PlatformInviewService } from 'src/app/core/services/utelize/general/platform-inview-service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-widget-row-platform',
  templateUrl: './widget-row-platform.component.html',
  styleUrls: ['./widget-row-platform.component.scss']
})

export class WidgetRowPlatformComponent implements OnDestroy, OnInit {

  @ViewChild('informationModalForm', { static: false }) informationModalForm!: InformationModalFormComponent;

  private modeSub: Subscription | undefined;

  public isPlatformModeInview: boolean=environment.platformModeInview;

  constructor(
    private exceptionsService    : ExceptionsService,
    private platformInviewService: PlatformInviewService,
    private router               : Router
  ) { }

  public ngOnInit(): void {
    try {

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngOnDestroy(): void {
    try {
      this.modeSub?.unsubscribe();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region Widget clicks

  public inviewClick(): void {
    try {
      this.informationModalForm.openForm('Coming Soon', '');
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public mdmClick(): void {
    try {
      this.router.navigate(['/device-management/mdm-dashboard']).then(() => {
        this.platformInviewService.setMode('mdm');
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public sureSimClick(): void {
    try {
      this.platformInviewService.setMode('suresim');
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
}
